import {
  Bell,
  BadgeCheck,
  Briefcase,
  CheckCircle2,
  Camera,
  AlertCircle as CircleAlert,
  MessageSquare,
  PartyPopper,
  Trophy,
  Wallet,
  XCircle,
  Sparkles,
  Lightbulb,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const ICONS: Record<string, { icon: LucideIcon; className: string }> = {
  new_offer: { icon: Briefcase, className: 'bg-brand-500/10 text-brand-600 dark:text-brand-300' },
  offer_accepted: { icon: CheckCircle2, className: 'bg-success/10 text-success' },
  offer_rejected: { icon: XCircle, className: 'bg-danger/10 text-danger' },
  new_message: { icon: MessageSquare, className: 'bg-brand-500/10 text-brand-600 dark:text-brand-300' },
  kyc_approved: { icon: BadgeCheck, className: 'bg-success/10 text-success' },
  kyc_rejected: { icon: CircleAlert, className: 'bg-warning/10 text-warning' },
  kyc_suspended: { icon: CircleAlert, className: 'bg-warning/10 text-warning' },
  payment_received: { icon: Wallet, className: 'bg-success/10 text-success' },
  ranking_change: { icon: Trophy, className: 'bg-warning/10 text-warning' },
  engagement_milestone: { icon: PartyPopper, className: 'bg-brand-500/10 text-brand-600 dark:text-brand-300' },
  new_season: { icon: Sparkles, className: 'bg-brand-500/10 text-brand-600 dark:text-brand-300' },
  card_published: { icon: Camera, className: 'bg-brand-500/10 text-brand-600 dark:text-brand-300' },
  feedback_update: { icon: Lightbulb, className: 'bg-success/10 text-success' },
};

/** Ícone de notificação por tipo (substitui os emojis do tema antigo). */
export function NotificationIcon({ type, className }: { type: string; className?: string }) {
  const entry = ICONS[type] ?? { icon: Bell, className: 'bg-ink/[0.06] text-muted' };
  const Icon = entry.icon;
  return (
    <span className={cn('flex h-8 w-8 shrink-0 items-center justify-center rounded-full', entry.className, className)} aria-hidden="true">
      <Icon className="h-4 w-4" />
    </span>
  );
}
